module.exports = __webpack_public_path__ + "static/media/Slack_Clone.794b59b8.mp4";